export { App as default } from '@guiker/booking-document-main-mfe'
